import { useSelector } from 'react-redux';
import { RootState } from 'store';

const useGetCurrentQuestionState = (questionId: any) => {
  const { gpsCoordinates } = useSelector((state: RootState) => state.surveyJS);
  const gpsCoordinatesList = Array.isArray(gpsCoordinates) ? gpsCoordinates : [];

  return gpsCoordinatesList.find((s: any) => s.id == questionId);
};

export { useGetCurrentQuestionState };
